import { takeEvery } from "@redux-saga/core/effects";
import { call, put } from "redux-saga/effects";

import * as types from "../Types/CategoryActionTypes";
import * as api from "../API/CategoryApi";
import * as actions from "../Actions/CategoryActions";
import { IBrandCategory } from "../../../Models/IBrandCategory";

export function* watchCategorySagas() {
    yield takeEvery(types.GET_ALL_CATEGORIES_INITIATE, getAllCategoriesSaga);
}

export function* getAllCategoriesSaga() {
    try {
        yield put(actions.setLoadingCategories(true));
        const categories: IBrandCategory[] = yield call(api.getCategories);
        yield put(actions.getAllCategoriesSuccess(categories));
    } catch (e) {
        yield put(actions.getAllCategoriesFailure());
    } finally {
        yield put(actions.setLoadingCategories(false));
    }
}
